import {
  CARD_TRANS_REFUND_STATUS,
  CARD_TRANS_STATUS,
  CARD_TRANSACTION_SHOW_STATUS,
  CARD_TRANSACTION_TYPE
} from "@/constant/Constant";

export const isTransDeclineExamption = (record) => {
  if (record.deductType == 1) {
    if (record.transactionDeduct?.realDeductOrderList?.length == 1) {
      const declineRealFee = record.transactionDeduct.realDeductOrderList[0];
      if (declineRealFee.amount == 0) {
        return true;
      }
    }
  }
  
  return false;
}

export const isTransSmallExamption = (record) => {
  if (record.deductType == 0) {
    if (record.transactionDeduct?.realDeductOrderList?.length == 1) {
      const declineRealFee = record.transactionDeduct.realDeductOrderList[0];
      if (declineRealFee.amount == 0) {
        return true;
      }
    }
  }
  
  return false;
}

export const getCardTransStatusColor = (record) => {
  if (!record) return '';
  // if (record.isRefund == 1 || record.hasRefund == 1) return 'error';
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED) {
    return '';
  } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.PENDING) {
    return '';
  } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.DECLINED) {
    return 'error';
  } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.DECLINED) {
    return 'error';
  }

  if (record.refundStatus == CARD_TRANS_REFUND_STATUS.PENDING) {
    return '';
  } else if (record.refundStatus == CARD_TRANS_REFUND_STATUS.SUCCESS) {
    return 'success'
  } else if (record.refundStatus == CARD_TRANS_REFUND_STATUS.FAIL) {
    return 'error'
  }
  return '';
}

export const getCardTransStatusColorV2 = (record) => {
  if ( !record) return '';
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.DECLINED) return 'error';
  if (record.refundStatus == CARD_TRANS_REFUND_STATUS.PENDING) return 'success';
  if (record.refundStatus == CARD_TRANS_REFUND_STATUS.SUCCESS) return '';
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED) return 'success'
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.PENDING) return 'success'
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.VOID) return 'warning'
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.DECLINED) return 'error'
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED_FULLY_REFUND) return 'warning'
  if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED_PARTIAL_REFUND) return 'warning'
  return '';
}

export const getRefundStatus = (item, t) => {
  if (item.refundStatus == CARD_TRANS_REFUND_STATUS.PENDING) {
    return t('card_trans_status_refund_pending');
  } else if (item.refundStatus == CARD_TRANS_REFUND_STATUS.SUCCESS) {
    return t('card_trans_status_refund_success');
  } else if (item.refundStatus == CARD_TRANS_REFUND_STATUS.FAIL) {
    return t('card_trans_status_refund_fail');
  } else if (item.refundStatus == CARD_TRANS_REFUND_STATUS.CANCEL) {
    return t('card_trans_status_refund_cancel');
  } else {
    return t('card_trans_status_refund_wait');
  }
}

export const _getStatusV2 = (record, t) => {
  if (record.transactionType == CARD_TRANSACTION_TYPE.CARD_TRANSACTION) {
    // if (record.status == CARD_TRANS_STATUS.CLEARED) {
    //   return t('card_trans_status_cleared')
    // } else if (record.status == CARD_TRANS_STATUS.VOID) {
    //   return t('card_trans_status_canceled')
    // } else if (record.status == CARD_TRANS_STATUS.PENDING) {
    //   return t('card_trans_status_pending')
    // } else if (record.status == CARD_TRANS_STATUS.DECLINED) {
    //   return t('card_trans_status_declined')
    // }
    if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.PENDING) {
      return t('card_trans_status_pending')
    } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED) {
      return t('card_trans_status_cleared')
    } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.REVERSAL) {
      return t('card_trans_status_reversal')
    } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED_FULLY_REFUND) {
      return t('card_trans_status_cleared')
    } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED_PARTIAL_REFUND) {
      return t('card_trans_status_cleared')
    } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.DECLINED) {
      return t('card_trans_status_declined')
    } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.VOID) {
      return t('card_trans_status_void')
    }
  } else if (record.transactionType == CARD_TRANSACTION_TYPE.VISA_TRANSFER) {
   return getRefundStatus(record, t);
  } else if (record.transactionType == CARD_TRANSACTION_TYPE.REFUND) {
    return getRefundStatus(record, t);
  } else if (record.transactionType == CARD_TRANSACTION_TYPE.CARD_TRANSACTION) {
    if (record.status == CARD_TRANS_STATUS.CLEARED) {
      return t('card_trans_status_cleared')
    }
  }
}


